import React from 'react';
import { Navigation } from '../components/Navigation';
import { PillIcon } from 'lucide-react';
export function Pharmacy() {
  return <div className="min-h-screen bg-gray-50 w-full" data-id="element-1892">
      <Navigation data-id="element-1893" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-1894">
        <div className="flex items-center space-x-3 mb-6" data-id="element-1895">
          <PillIcon className="w-8 h-8 text-pink-600" data-id="element-1896" />
          <div data-id="element-1897">
            <h1 className="text-3xl font-bold text-gray-900" data-id="element-1898">Pharmacy</h1>
            <p className="text-gray-600" data-id="element-1899">
              Integrated chemist and pharmacy management
            </p>
          </div>
        </div>
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8 text-center" data-id="element-1900">
          <p className="text-gray-500" data-id="element-1901">
            Pharmacy features will be implemented here
          </p>
        </div>
      </div>
    </div>;
}